'use client';

import React from 'react';
import QCReviewHeader from './components/QCReviewHeader';
import QCReviewBoard from './components/QCReviewBoard';

export default function QCReviewPage() {
  return (
    <div className="flex flex-col min-h-screen bg-background">
      <QCReviewHeader />
      <QCReviewBoard />
    </div>
  );
}
